import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=681adf2e&"
import script from "./ResetPassword.js?vue&type=script&lang=js&"
export * from "./ResetPassword.js?vue&type=script&lang=js&"
import style0 from "./ResetPassword.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports